import { Link } from 'react-router-dom';
import { getAuthor, getCategory } from '../../content/engine/postIndex';

export default function ArticleCard({ post, priority = false }) {
  const author = getAuthor(post.author);
  const category = getCategory(post.category);

  return (
    <article className="article-card">
      <Link to={`/blog/${post.slug}`} className="article-card-cover-link">
        <div className="article-card-cover">
          <img
            src={post.cover}
            alt={post.coverAlt}
            loading={priority ? undefined : 'lazy'}
            decoding="async"
            fetchpriority={priority ? 'high' : undefined}
          />
        </div>
      </Link>
      <div className="article-card-body">
        {category && (
          <Link to={`/blog/category/${category.slug}`} className="article-card-cat">
            {category.name}
          </Link>
        )}
        <h3 className="article-card-title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>
        <p className="article-card-excerpt">{post.excerpt}</p>
        <div className="article-card-meta">
          {author && <span>{author.name}</span>}
          <span className="dot">·</span>
          <span>{post.readingTime} min read</span>
        </div>
      </div>
    </article>
  );
}
